var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style[`cc-popbox-loading`]},[_c('div',{class:_vm.$style[`cc-popbox-loading-wrap`]},[_c('IconLoading',{attrs:{"size":60,"color":`#b1b1b1`}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }